import * as R from 'ramda'
import * as lodash from 'lodash'

export function rentalEmailPrefixFromName(name: string) {
  return lodash
    .trim(name)
    .toLowerCase()
    .replace(/[^a-zA-Z0-9 ]/g, '')
    .split(/\s+/)
    .join('.')
}

export function convertToTokeetEmail(handle: string, subDomain: string): string {
  return R.pipe(R.split('@'), R.take(1), R.append('@'), R.append(subDomain), R.join(''))(handle)
}
